import {LabTestResult} from '../../lab-test-results/lab-test-result';
import * as moment from 'moment';
import { isEmpty, sortBy } from 'lodash';

export class StandardTestResultsData {
    public zcSubjectId: string;
    public subjectNumber: string;
    public screeningNumber: string;
    public initials: string;
    public sex: string;
    public age: number;
    public ageUnit: string;
    public ageProjectDisplayValue: string;
    public isAgeProject: boolean;
    public hasSubjectDataRevision: boolean;
    public hasVisitDataRevision: boolean;
    public visitCollectionDate: moment.Moment;
    public visitCollectionDateValue: number;
    public visitName: string;
    public visitDescription: string;
    public accessionNumber: string;
    public test: string;
    public testGroup: string;
    public labTestResults: LabTestResult[];
    public isOptional: boolean;
    public isQuestion: boolean;
    public exportSortId: number;

    constructor(combinedResults: LabTestResult[], exportSortId?: number) {
        if (isEmpty(combinedResults)) {
            return null;
        }

        const combinedSortFields: (keyof LabTestResult)[] = ['testSequence', 'resultSequence'];

        if (exportSortId) {
            combinedResults.forEach(cr => cr.exportSortId = exportSortId);            
        }

        const item = combinedResults[0];

        this.zcSubjectId = item.zcSubjectId;
        this.subjectNumber = item.subjectNumber;
        this.screeningNumber = item.screeningNumber;
        this.initials = item.initials;
        this.sex = item.sex;
        this.age = item.age;
        this.ageUnit = item.ageUnit;
        this.ageProjectDisplayValue = item.ageProjectDisplayValue;
        this.isAgeProject = item.isAgeProject;
        this.hasSubjectDataRevision = item.hasSubjectDataRevision;
        this.hasVisitDataRevision = item.hasVisitDataRevision;
        this.accessionNumber = item.accessionNumber;
        this.visitName = item.visitName;
        this.visitCollectionDate = item.visitCollectionDate;
        this.visitCollectionDateValue = item.visitCollectionDateValue;
        this.visitDescription = item.visitDescription;
        this.test = item.test;
        this.testGroup = item.testGroup;
        this.labTestResults = sortBy(combinedResults, combinedSortFields);
        this.isOptional = item.isOptional;
        this.isQuestion = item.isQuestion;
        this.exportSortId = exportSortId ? exportSortId : item.exportSortId;
    }

    public setLabTestResultExportSortId(exportSortId: number) {
        this.labTestResults.forEach(res => {
            this.exportSortId = exportSortId;
            res.exportSortId = exportSortId;
        });

    }
}